import axios from 'axios';

const state = {
    application: null,
    team: null,
    source: null,
    integration: {
        id: null,
        start_date: null,
        permissions: [],
        scope: 'all',
        targets: [],
        application_id: null,
        source_id: null,
        target_id: null
    }
};

//TODO Applications that require a target_id

const mutations = {
    team(state, team){
        state.team = team;
    },
    application(state, application){
        state.application = application;
        state.integration.application_id = application.id;
    },
    source(state, source){
        state.source = source;
        state.integration.source_id = source.id;
    },
    permissions(state, payload){
        state.integration.permissions = payload;
    },
    scope(state, scope){
        state.integration.scope = scope;
    },
    id(state, id){
        state.integration.id = id;
    }
};

const actions = {
    application({commit}, application_id){
        return axios.get(`/marketplace/${application_id}`)
        .then(response => commit('application', response.$data));
    },
    team({commit}, team){
        commit('team', team);
    },
    source({commit}, source){
        commit('source', source);
    },
    permissions({commit}, payload){
        commit('permissions', payload);
    },
    scope({commit}, payload){
        commit('scope', payload);
    },
    id({commit}, id){
        commit('id', id);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
